import React from 'react';
import { useTranslation } from 'react-i18next';
import LinkedInLogo from '../assets/linkedin_blue.svg';

const Contact = () => {
    const { t } = useTranslation();

    return (
        <section className="section" id="contact">
            <h2 className="section__title">{t('contactTitle')}</h2>
            <div className="section__title-underline"></div>
            <div className="contact">
                <a className="contact__email" href="mailto:villaverdepeiro@gmail.com">villaverdepeiro@gmail.com</a>
                <span className="contact__location">Vancouver BC, Canada</span>
                <a
                    className="contact__linkedin"
                    href="https://www.linkedin.com/in/hector-villaverde-9a24019/"
                    target="_blank"
                    rel="noreferrer"
                >
                    <img className="contact__linkedin-icon" src={LinkedInLogo} alt={t('linkedinAlt')} />
                </a>
            </div>
        </section>
    );
};

export default Contact;
